import { render, staticRenderFns } from "./SmartLeadCard.vue?vue&type=template&id=25bc8440&scoped=true"
import script from "./SmartLeadCard.vue?vue&type=script&lang=js"
export * from "./SmartLeadCard.vue?vue&type=script&lang=js"
import style0 from "./SmartLeadCard.vue?vue&type=style&index=0&id=25bc8440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bc8440",
  null
  
)

export default component.exports